import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import H3Text from '@Uilib/h3Text';

import './style.scss';

function H3Progress({
  percent, barWidth,
}) {
  const getBarBg = () => {
    if (percent > 100) return '#FF5630';
    if (percent >= 75 && percent <= 100) return '#28c54d';
    if (percent >= 25 && percent < 75) return '#ffa530';
    if (percent > 0 && percent < 25) return '#f5c72f';
    return '#fafafa';
  };
  return (
    <div className="h3-progress-wrapper">
      <div className="h3-progress__bar" style={{ width: barWidth || '150px' }}>
        <div className="h3-progress__bar-filled" style={{ backgroundColor: getBarBg(), width: percent > 100 ? '100%' : `${percent || '0'}%` }} />
      </div>
      <H3Text text={`${percent >= 0 ? percent?.toFixed(0) : '0'}%`} className="h3-progress__bar-text" />
    </div>
  );
}

const mapStateToProps = ({

}) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

H3Progress.propTypes = {
  percent: PropTypes.number,
  barWidth: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(H3Progress));
